export * from './set-password-ui.component';
export * from './set-password-ui.module';
